// src/components/store/sections/faqs/FaqV59AccordioncleanFuchsiaGlow.tsx
"use client";

import React from "react";
import DynamicFaqVariant from "./DynamicFaqVariant";

export default function FaqV59AccordioncleanFuchsiaGlow(props: any) {
  return (
    <DynamicFaqVariant
      variantNumber={59}
      archKey="accordion_clean"
      archLabel="Clean Emerald Accordion"
      palName="FuchsiaGlow"
      grad="from-fuchsia-500 via-pink-500 to-purple-700"
      lightBg="bg-fuchsia-50"
      textCol="text-fuchsia-700"
      borderCol="border-fuchsia-200"
      btnCls="bg-fuchsia-600 hover:bg-fuchsia-700"
      hexCol="#d946ef"
      {...props}
    />
  );
}
